import {
    call,
    put,
    select,
    takeLatest
} from 'redux-saga/effects';

import { logError } from '../utils/errorUtils';
import {
    getPaypalClientID
} from '../brand/brandSelectors';
import { getPaypalLocaleCode } from './paypalSelectors';
import {
    importPayPalLocaleMap,
    loadPaypal,
    paypalLoaded,
    paypalAuthFailed,
    START_PAYPAL_LOAD
} from './paypalModule';


export function* paypalLoaderSaga() {
    const payPalLocaleMap = (yield call(importPayPalLocaleMap)).default;
    const localeCode = (yield select(getPaypalLocaleCode))(payPalLocaleMap);
    const paypalId = yield select(getPaypalClientID);
    try {
        yield call(loadPaypal, paypalId, localeCode);
    } catch (event) {
        logError('Error loading PayPal SDK', { paypalId });
        yield put(paypalAuthFailed());
    }
    yield put(paypalLoaded());
}

export function* watchPaypalSagas() {
    yield takeLatest(START_PAYPAL_LOAD, paypalLoaderSaga);
}
